import { rem } from "@huub-web/utils/css/rem";
import { style } from "@vanilla-extract/css";

export const indicatorStyle = style({
  transform: `translate(${rem(-2)}, ${rem(-2)})`,
});
